import { Col, DatePicker, Form, Input, Row, TreeSelect } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import { t } from 'i18next'
import React, { useContext, useState } from 'react'
import PhoneInput from 'react-phone-number-input'
import { displayCommunication, intervenerOptionsForAppointment } from '../../Common/Common'
import BoxContext from '../BoxPage/BoxContext'
const { RangePicker } = DatePicker

export default function WorkAppointmentForm ({ form, onDateChange, rangeDisable }) {
  const { box } = useContext(BoxContext)
  const interveners = [...box.interveners, ...box.internal_interveners]
  const [phones, setPhones] = useState([])
  const [emails, setEmails] = useState([])

  const onChange = (value) => {
    const intervener = interveners.find(i => i.id === value)
    setPhones(intervener.phones)
    setEmails(intervener.emails)
    const values = {
      first_name: intervener.first_name,
      last_name: intervener.last_name
    }
    let phone = '+33'
    let email = ''
    if (intervener.phones.length === 1) {
      phone = `+${intervener.phones[0].value}`
    }
    if (intervener.emails.length === 1) {
      email = intervener.emails[0].value
    }
    form.setFieldsValue({ ...values, phone, email })
  }

  return (
    <>
      <Row gutter={16}>
        <Col>
          <Form.Item name="appointment_date" label={t('Admin.AppointmentForm.appointment_date')} >
            <DatePicker
              format={'DD/MM/YY HH[h]mm'}
              disabled />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name="range" label={t('Admin.AppointmentForm.range')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <RangePicker
              onChange={onDateChange}
              showTime={{ format: 'HH[h]mm' }}
              format={'DD/MM/YY HH[h]mm'}
              disabled={rangeDisable} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name='intervener' label={t('Admin.AppointmentForm.intervener')}>
        <TreeSelect treeData={intervenerOptionsForAppointment()} onChange={onChange} treeDefaultExpandAll style={{ width: '60%' }} />
      </Form.Item>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="first_name" label={t('Admin.AppointmentForm.first_name')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="last_name" label={t('Admin.AppointmentForm.last_name')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col style={{ maxWidth: '25%' }}>
          <Form.Item name="phone" label={t('Admin.AppointmentForm.phone')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <PhoneInput className='ant-input css-dev-only-do-not-override-xfszwz'
              international defaultCountry={'FR'}
            />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name="email" label={t('Admin.AppointmentForm.email')}>
            <Input />
          </Form.Item>
        </Col>
        {phones.length > 1 &&
          <Col span={4}>
            <h3 style={{ margin: 0 }}>{t('Admin.IntervenerForm.phones')}</h3>
            {phones.map(phone => displayCommunication(phone))}
          </Col>
        }
        {emails.length > 1 &&
          <Col span={6}>
            <h3 style={{ margin: 0 }}>{t('Admin.IntervenerForm.emails')}</h3>
            {emails.map(email => displayCommunication(email))}
          </Col>
        }
      </Row>
      <Form.Item name="comment" label={t('Admin.AppointmentForm.comment')}
        rules={[{ required: true, message: t('rules.required') }]}>
        <TextArea rows={5} />
      </Form.Item>
      <Form.Item name="is_now">
        <Input type='hidden' />
      </Form.Item>
    </>
  )
}
